<script setup lang="ts">
import type { ContentCardCarouselBlockProps } from "./ContentCardCarouselBlock.types";
import { DsCarousel } from '@coloplast/design-system';
import '@coloplast/design-system/dist/components/carousel/ds-carousel.css';

const props = defineProps<ContentCardCarouselBlockProps>();
</script>

<template>
	<DsCarousel
		:ariaLabelNext="props.vm.CurrentBlock.NextButtonLabel ?? 'Next'"
		:ariaLabelPrev="props.vm.CurrentBlock.PreviousButtonLabel ?? 'Previous'"
		:linkText="props.vm.CurrentBlock.RightBottomLinkText"
		:linkUrl="props.vm.BaseViewModel.RightBottomLinkUrl"
		:linkTarget="props.vm.CurrentBlock.RightBottomLinkTarget"
		:maxItemsPerView="props.vm.CurrentBlock.CardCountOnDesktop === '3' ? 3 : 4"
	>
		<template #header>
			<slot name="carouselheader"></slot>
		</template>

		<slot></slot>
	</DsCarousel>
</template>
